module.exports = __webpack_public_path__ + "img/nuage_on.57752eea.gif";